import type { Locale } from '@infiltre/shared';
import { useT } from '@/shared/lib/i18n';
import { AdaptiveDialog } from './AdaptiveDialog';
import { DossierBriefingPanel } from './DossierBriefingPanel';

export type HostSettingsSheetProps = {
  open: boolean;
  onClose: () => void;
  includeClochard: boolean;
  onIncludeClochardChange: (v: boolean) => void;
  discussionSeconds: number;
  onDiscussionSecondsChange: (s: number) => void;
  infiltreCount: number;
  onInfiltreCountChange: (n: number) => void;
  locale: Locale;
  onLocaleChange: (l: Locale) => void;
  playerCount: number;
  minPlayers?: number;
  disabled?: boolean;
};

/**
 * Mobile bottom sheet for host room settings. Renders the dossier paper
 * directly as the sheet surface (`bare`) so the paper is what slides up
 * — no cream chrome, drag handle, or rounded corners around it. The
 * panel's footer (ready label + DISTRIBUER CTA) is hidden — the start
 * action lives in `MobileLobbyFooter` outside the sheet.
 */
export const HostSettingsSheet = ({ open, onClose, ...rest }: HostSettingsSheetProps) => {
  const t = useT();

  return (
    <AdaptiveDialog
      open={open}
      onClose={onClose}
      ariaLabel={t('setup.host_settings.title')}
      closeLabel={t('settings.close')}
      surface="bare"
      hideHandle
    >
      <DossierBriefingPanel {...rest} onStart={() => undefined} tilt={0} hideFooter />
    </AdaptiveDialog>
  );
};
